import FileSelector from './FileSelector';
import Button from '../ui/Button';

import './AddReviewDocumentForm.scss';

const AddReviewDocumentForm = ({
	docsConfirmLabel,
	onDocsConfirm,
	onCancel
}) => {
	return (
		<div>
			<FileSelector
				title='Documents'
				label='Upload documents like events schedule, clinical trial, etc.'
				multiple={true}
				documentType='reviewRequestDocuments'
			></FileSelector>
			<div className='add-review-actions'>
				<Button
					onClick={onDocsConfirm}
					className='primary-button'
				>
					{docsConfirmLabel}
				</Button>
				<Button
					onClick={onCancel}
					className='secondary-button'
				>
					Cancel
				</Button>
			</div>
		</div>
	);
};

export default AddReviewDocumentForm;
